import React from 'react';
import { Tooltip as TooltipAntd } from 'antd';
import type { TooltipPlacement } from 'antd/lib/tooltip';
import cn from 'classnames';
import type { TooltipProps } from './types';
import './tooltip.scss';

const DEFAULT_PLACEMENT: TooltipPlacement = 'topLeft';

export const Tooltip: React.FC<TooltipProps> = ({ children, className, placement, label, white }) => (
  <TooltipAntd
    overlayClassName={cn('tooltip-default', { white }, className)}
    overlay={label}
    placement={placement ?? DEFAULT_PLACEMENT}
    destroyTooltipOnHide
  >
    {children}
  </TooltipAntd>
);
